import React from 'react'
import styled from 'styled-components'

import MenuItem from '../MenuItem'
import { MysqlCategories } from '../../../graphqlTypes'

const Item = styled.li`
  display: inline-block;
  font-size: 12px;
  font-weight: bold;
  width: 100%;
`

const CategoryTitle = styled.p`
  background: ${({ theme }) => theme.palette.primary.light};
  color: ${({ theme }) => theme.palette.font.light};
  padding: 10px;
  text-align: left;
  vertical-align: middle;
`

const Menu = styled.ul`
  list-style: none;
  width: 100%;
`

export default function CategoryItem({ category }: { category: MysqlCategories }) {
  if (!category.categories || !category.categories.length) return null

  const categories = category.categories as MysqlCategories[]

  return (
    <Item>
      <CategoryTitle>{category.title}</CategoryTitle>
      <Menu>
        {categories.map((category) => (
          <MenuItem category={category} key={category.id} />
        ))}
      </Menu>
    </Item>
  )
}
